import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutUsComponent } from './components/about/about-us/about-us.component';
import { ContactUsComponent } from './components/contact/contact-us/contact-us.component';
import { FAQsComponent } from './components/FAQs/faqs/faqs.component';
import { LandingComponent } from './landing-page/landing/landing.component';
import { OrganizationsComponent } from './components/organizations/organizations.component';
import { TermsConditionsComponent } from './components/terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';

const routes: Routes = [
  { path: "", component: LandingComponent },
  { path: "", redirectTo: "", pathMatch: "full" },
  { path: "FAQs", component: FAQsComponent },
  { path: "about", component: AboutUsComponent },
  { path: "contact-us", component: ContactUsComponent },
  { path: "organizations", component: OrganizationsComponent },
  { path: "terms-&-conditions", component: TermsConditionsComponent },
  { path: "privacy-policy", component: PrivacyPolicyComponent },
];

@NgModule({
  imports: [   RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled', // Restores scroll position
    anchorScrolling: 'enabled',           // Optional: Enables anchor scrolling
    // Optionally, you can also add other router options here
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
